import { render, staticRenderFns } from "./proClassify.vue?vue&type=template&id=5e39491f&"
import script from "./proClassify.vue?vue&type=script&lang=js&"
export * from "./proClassify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports